import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Typography,
} from '@mui/material';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import { useTranslation } from 'react-i18next';

export const webviewIssueMessage = (t, issue) =>
  t('views.redesignScreens.webviewUnsupportedPlayback', {
    defaultValue: "Playback for {{name}} isn't supported on this device.",
    name: issue.name,
  });

export default function WebviewWarningDialog({
  open,
  issues,
  onConfirm,
  onCancel,
}) {
  const { t } = useTranslation();

  return (
    <Dialog open={open} onClose={onCancel} maxWidth='xs' fullWidth>
      <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <WarningAmberIcon color='warning' />
        {t('views.redesignScreens.webviewWarningTitle', {
          defaultValue: 'Content may not play on this device',
        })}
      </DialogTitle>
      <DialogContent>
        <DialogContentText sx={{ mb: 1 }}>
          {t('views.redesignScreens.webviewWarningText', {
            defaultValue:
              'This device runs Android 9 or older. The content below needs a modern web engine and may show a black screen.',
          })}
        </DialogContentText>
        {(issues || []).map((issue, i) => (
          <Typography key={`${issue.id}-${i}`} variant='body2'>
            • {webviewIssueMessage(t, issue)}
          </Typography>
        ))}
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button variant='outlined' color='error' onClick={onCancel}>
          {t('views.redesignScreens.noCancel')}
        </Button>
        <Button variant='contained' onClick={onConfirm}>
          {t('views.redesignScreens.webviewWarningConfirm', {
            defaultValue: 'Set anyway',
          })}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
